import m from "mithril";

export const LoginErrorLabel: m.Component<{ error: boolean }> = {
  view({ attrs: { error } }) {
    if (error) {
      return m("div.my-4", {}, m("div.text-amber-300", "Invalid credentials"));
    }
  },
};
